export const CPC_MAPS = [
  { name: 'Biogear Lab',       slug: 'biogear-lab',       file: 'Biogear lab.png' },
  { name: 'Campaings Forge',   slug: 'campaings-forge',   file: 'Campaings forge.png' },
  { name: 'Elon Station Gray', slug: 'elon-station-gray', file: 'Elon station gray.png' },
  { name: 'Forbidden City',    slug: 'forbidden-city',    file: 'Forbidden city.png' },
  { name: 'Imperial Temple',   slug: 'imperial-temple',   file: 'Imperial temple.png' },
  { name: 'Mech Arena',        slug: 'mech-arena',        file: 'Mech Arena.png' },
  { name: 'Mesa Verde Annex',  slug: 'mesa-verde-annex',  file: 'Mesa verde annex.png' },
  { name: 'Paradise Plaza',    slug: 'paradise-plaza',    file: 'Paradise plaza.png' },
  { name: 'Patterson Station', slug: 'patterson-station', file: 'Patterson station.png' },
  { name: 'Scarlet Atrium',    slug: 'scarlet-atrium',    file: 'Scarlet atrium.png' },
  { name: 'Site 313',          slug: 'site-313',          file: 'Site 313.png' },
  { name: 'Skyship 11',        slug: 'skyship-11',        file: 'Skyship 11.png' },
  { name: 'Smokestacks',       slug: 'smokestacks',       file: 'Smokestacks.png' },
];
